// /User/ui_design/src/Components/Home.js
import React from "react";

// Local images
import pennLogo from "../images/UniversityofPennsylvania_FullLogo_RGB-4_0.png";
import logo1 from "../images/image-removebg-preview (1).png";
import logo2 from "../images/image-removebg-preview (2).png";
import logo3 from "../images/image-removebg-preview (3).png";
import logo4 from "../images/image-removebg-preview (4).png";

// Sections
import Mission from "./Mission";
import Story from "./Story";
import PatientsFirst from "./PatientsFirst";
import Counter from "./Counter";
import BottomImageCarousel from "./BottomImageCarousel";


// Carousel
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

// --- SPONSOR / GALLERY COMPONENT ---
function Gallery() {
  const images = [logo1, pennLogo, logo2, logo3, logo4];

  const sectionStyle = {
    padding: "40px 0",
    backgroundColor: "white",
  };

  const titleStyle = {
    textAlign: "center",
    marginBottom: "30px",
    fontSize: "clamp(22px, 2.4vw, 32px)",
    fontWeight: 700,
  };

  return (
    <section id="Sponsors" style={sectionStyle}>
      <h2 style={titleStyle}>Our Partners & Sponsors</h2>

      <div
        style={{
          maxWidth: 1150,
          margin: "0 auto",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#ffffffff"
        }}
      >
        <Carousel
          showThumbs={false}
          showStatus={false}
          showIndicators={false}
          infiniteLoop
          autoPlay
          interval={3000}
          swipeable
          emulateTouch
          dynamicHeight={false}
          stopOnHover={false}
          centerMode
          centerSlidePercentage={40}
        >

          {images.map((src, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: 180,
                padding: "10px 0",
                backgroundColor: "#ffffffff"
              }}
            >
              <img
                src={src}
                alt={`Sponsor ${index + 1}`}
                style={{
                  height: "200px",
                  width: "auto",
                  objectFit: "contain",
                  margin: "0 auto",
                  backgroundColor: "#ffffffff"
                }}
              />
            </div>
          ))}
        </Carousel>
      </div>
    </section>
  );
}

// --- MAIN HOME COMPONENT ---
export default function Home({ counter }) {
  return (
    <div>
      <Mission />

      <div style={{ marginTop: "32px" }}>
        <Counter counter={counter} />
      </div>

      <Gallery />

      <PatientsFirst />
      <Story />
      <BottomImageCarousel />

    </div>
  );
}
